import type { BillingLine } from '../../services/api';
import { formatCents, formatQuantity } from '../../services/format';

const SOURCE_LABEL: Record<string, string> = {
  plan: 'Plan', seat: 'Seats', module: 'Modul', usage: 'Nutzung', manual: 'Manuell', model: 'Modell', opencost: 'OpenCost',
};

interface Props {
  lines: Array<BillingLine & { tenantSlug?: string }>;
  showTenant?: boolean;
  emptyText?: string;
  totalLabel?: string;
}

/** Positionstabelle (Erlös oder Kosten) mit Summenzeile. */
export function LineItemsTable({ lines, showTenant, emptyText = 'Keine Positionen.', totalLabel = 'Summe' }: Props) {
  const total = lines.reduce((s, l) => s + l.amountCents, 0);
  return (
    <table className="w-full text-sm">
      <thead className="bg-slate-100 text-left">
        <tr>
          {showTenant && <th className="p-2">Tenant</th>}
          <th className="p-2">Position</th>
          <th className="p-2 text-right">Menge</th>
          <th className="p-2 text-right">Einzelpreis</th>
          <th className="p-2 text-right">Betrag</th>
          <th className="p-2">Quelle</th>
        </tr>
      </thead>
      <tbody>
        {lines.map((l, i) => (
          <tr key={`${l.tenantSlug ?? ''}-${l.code}-${i}`} className="border-t">
            {showTenant && <td className="p-2 font-mono text-xs">{l.tenantSlug}</td>}
            <td className="p-2">
              {l.description}
              <span className="block text-xs text-slate-400 font-mono">{l.code}</span>
            </td>
            <td className="p-2 text-right font-mono">{formatQuantity(l.quantity, l.unit)}</td>
            <td className="p-2 text-right font-mono">{formatCents(l.unitPriceCents)}</td>
            <td className={`p-2 text-right font-mono ${l.amountCents < 0 ? 'text-green-700' : ''}`}>{formatCents(l.amountCents)}</td>
            <td className="p-2"><span className="badge bg-slate-100 text-slate-600">{SOURCE_LABEL[l.source] ?? l.source}</span></td>
          </tr>
        ))}
        {lines.length === 0 && (
          <tr><td colSpan={showTenant ? 6 : 5} className="p-3 text-center text-slate-400">{emptyText}</td></tr>
        )}
      </tbody>
      {lines.length > 0 && (
        <tfoot>
          <tr className="border-t bg-slate-50 font-semibold">
            <td className="p-2" colSpan={showTenant ? 4 : 3}>{totalLabel}</td>
            <td className="p-2 text-right font-mono">{formatCents(total)}</td>
            <td />
          </tr>
        </tfoot>
      )}
    </table>
  );
}
